import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { selectSubmitFormData } from '../../selectors/selectSubmitFormData';
import { QuizCompletedSuccess } from '../../components/QuizCompleteSuccess/QuizCompletedSuccess';
import { useGetQuizCompletedSuccessProps } from './utils/useGetQuizCompletedSuccessProps';
import { TThunkDispatch } from '../../types/redux';
import { getStatusAboutChatMessage } from '../../actions/submitForm/getStatusAboutChatMessage';
import { selectIsWebview } from '../../selectors/selectIsWebview';

//  TODO: переписать, полностью изолировав логику запроса chatId и перехода в useGetQuizCompletedSuccessProps
export const QuizCompletedContainer: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = () => {
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false);
  const dispatch = useDispatch<TThunkDispatch>();
  const submitFormData = useSelector(selectSubmitFormData);
  const sentMessageFromCian = true;
  const isWebview = useSelector(selectIsWebview);
  const chatInfo = submitFormData?.chat;

  const quizCompletedSuccessProps = useGetQuizCompletedSuccessProps(isChatOpen, chatInfo);

  useEffect(() => {
    if (sentMessageFromCian) {
      const timerForOpenChat = setTimeout(async () => {
        await dispatch(getStatusAboutChatMessage());
      }, 3000);

      return () => clearTimeout(timerForOpenChat);
    }

    return;
  }, [sentMessageFromCian]);

  useEffect(() => {
    if (chatInfo) {
      quizCompletedSuccessProps.handleOpenChat();

      //Создаем задержку для отрисовки кнопки
      if (!isWebview) {
        setTimeout(async () => {
          setIsChatOpen(true);
        }, 1000);
      }
    }
  }, [chatInfo]);

  return <QuizCompletedSuccess {...quizCompletedSuccessProps} />;
};

QuizCompletedContainer.displayName = 'QuizCompletedContainer';
